import styled from 'styled-components';

export const StyledSpan = styled.span`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 180%;
  color: #C4C4C4;
  padding: 0 15px;
  display: inline-block;
  margin-bottom: 10px;
  cursor: pointer;
  &.RightBorder{
    border-right: 1px solid #000;
  }
  &.FilterIcon{
    opacity: 0.3;
  }
  &:hover{
    color: #1C62EF;
    opacity: 1;
  }
  &.ChosenFilter{
    color: #1C62EF;
    opacity: 1;
  }
`;

export const Icon = styled.img`
  width: 24px;
`
